import PropTypes from 'prop-types';
import React, { Component } from 'react';
import connectToStores from 'fluxible-addons-react/connectToStores';
import uriJs from 'urijs';
import getCsrfToken from './lib/getCsrfToken';

// stores
import DesignCollectionStore from './stores/DesignCollectionStore';
import DesignCommentsStore from './stores/DesignCommentsStore';
import DesignSketchesStore from './stores/DesignSketchesStore';
import AppComponent from './components/AppComponent';

// actions
import {
    setDesignData,
    setDesignCollection,
    loadDesign,
    loadMoreDesigns,
} from './actions/set-design-data';

import { resetSelectedComment, resetComments, loadDesignComments } from './actions/design-comments';

import { loadDesignSketches } from './actions/design-sketches';

import user from './models/user';

export default function ddo({
    fluxibleApp,
    fluxibleContext,
    activeUser = {},
    designCollection = null,
    isInline = false,
    models = {},
    goBack = () => undefined,
    goTo = () => undefined,
    csrfToken = null,
}) {
    [DesignCollectionStore, DesignCommentsStore, DesignSketchesStore].map(
        fluxibleApp.registerStore,
        fluxibleApp
    );

    fluxibleContext.getStore(DesignCommentsStore).setModel(models.designComment);
    fluxibleContext
        .getStore(DesignCommentsStore)
        .setCollectionModel(models.designCommentCollection);
    fluxibleContext.getStore(DesignCollectionStore).setModel(models.design);
    fluxibleContext.getStore(DesignCollectionStore).setCollectionModel(models.designCollection);

    if (designCollection) {
        fluxibleContext.getStore(DesignCollectionStore).setDesignCollection(designCollection);
    }

    const ConnectedAppComponent = connectToStores(
        AppComponent,
        [DesignCollectionStore, DesignCommentsStore],
        (ctx, props) => {
            const collectionStore = ctx.getStore(DesignCollectionStore);
            const design = collectionStore.getDesign(props.designId);
            const nextDesign = collectionStore.getNextDesign(props.designId);
            const previousDesign = collectionStore.getPreviousDesign(props.designId);

            if (window.Bugsnag && !design) {
                window.Bugsnag.notify(
                    'ddo-missing-design',
                    `DDO missing designid: ${props.designId}`,
                    {
                        designId: props.designId,
                        len: collectionStore.designs.length,
                        designs: JSON.stringify(collectionStore.designs.map(d => d.designId)),
                    }
                );
            }

            return {
                design: design,
                nextPageUrl: collectionStore.nextPageUrl,
                prevPageUrl: collectionStore.prevPageUrl,
                previousDesign: previousDesign,
                nextDesign: nextDesign,
                selectedComment: ctx.getStore(DesignCommentsStore).selectedComment,
                isInline,
                goBack,
                goToNext: () => {
                    if (!nextDesign) return;

                    goTo(uriJs(nextDesign.showUrl).resource());
                },
                goToPrevious: () => {
                    if (!previousDesign) return;

                    goTo(uriJs(previousDesign.showUrl).resource());
                },
                clearDesignCommentSelection: () => {
                    ctx.executeAction(resetSelectedComment);
                },
            };
        },
        {
            executeAction: PropTypes.func,
        }
    );

    class DdoComponent extends Component {
        getChildContext() {
            return {
                activeUser: user.fromJSON(activeUser),
                csrfToken: csrfToken || getCsrfToken(),
                scribblesEnabled: true,
            };
        }

        componentWillReceiveProps(nextProps) {
            if (nextProps.designId !== this.props.designId) {
                this.setDesign(nextProps.designId);
            }
        }

        componentDidMount() {
            this.setDesign(this.props.designId);
        }

        setDesign(designId) {
            this.context.executeAction(loadDesign, designId);
            this.context.executeAction(loadMoreDesigns, designId);
            this.context.executeAction(resetComments);

            const design = this.context.getStore(DesignCollectionStore).getDesign(designId);

            if (design.links.comments && design.permission.canViewComments) {
                this.context.executeAction(loadDesignComments, {
                    commentsUrl: design.links.comments,
                    designId: design.designId,
                });
            }

            if (design.links.sketches && design.permission.canViewSketches) {
                this.context.executeAction(loadDesignSketches, {
                    loadDesignSketchesUrl: design.links.sketches,
                    designId: design.designId,
                });
            }
        }

        render() {
            return <ConnectedAppComponent {...this.props} />;
        }
    }

    DdoComponent.propTypes = {
        designId: PropTypes.string.isRequired,
    };

    DdoComponent.contextTypes = {
        executeAction: PropTypes.func,
        getStore: PropTypes.func,
    };

    DdoComponent.childContextTypes = {
        activeUser: PropTypes.object,
        csrfToken: PropTypes.string,
        scribblesEnabled: PropTypes.bool,
    };

    // -----------
    // PUBLIC API
    // -----------
    return {
        DdoComponent,

        setDesignCollection(designCollection) {
            return fluxibleContext.executeAction(setDesignCollection, designCollection);
        },

        setDesignData(design) {
            return fluxibleContext.executeAction(setDesignData, design);
        },
    };
}



// WEBPACK FOOTER //
// ./~/@99designs/ddo/index.js